import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Achievments from '@/components/Achievments'
import Equipments from '@/components/Equipments'
import Contacts from '@/components/Contacts'
import ServiceWrapper from '@/components/ServiceWrapper'
Vue.use(Router)

var router = new Router({
  mode: 'history',
  pathToRegexpOptions: { strict: true },
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/achievments',
      name: 'Achievments',
      component: Achievments
    },
    {
      path: '/equipments',
      name: 'Equipments',
      component: Equipments
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Contacts,
      props: true
    },
    {
      path: '/service/:name',
      name: 'ServiceWrapper',
      component: ServiceWrapper,
      props: true
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js